import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import Login from "./containers/Auth"
import { isLoggedIn } from './utils';
import MainContainer from "./containers/Main"
import Dashboard from './containers/Dashboard';
import AudioCatalog from './containers/Releases/AudioCatalog';
import VideoCatalog from './containers/Releases/VideoCatalog';
import ViewReleases from './containers/Releases/ViewReleases';
import SubLabels from './containers/Releases/SubLabels';

const PriavteRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn() ? (
        <MainContainer {...props}>
          <Component {...props} />
        </MainContainer>
      )
        : (
          <Redirect to='/login' />
        )
    }
  />
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => isLoggedIn() ? <Redirect to="/" /> : <Component {...props} />
    }
  />
);

export default function App() {
  return (
    <Router>
      <Switch>
        <PriavteRoute exact path="/" component={Dashboard} />
        <PublicRoute exact path='/login' component={Login} />
        <PriavteRoute exact path="/audio-catalog" component={AudioCatalog} />
        <PriavteRoute exact path="/video-catalog" component={VideoCatalog} />
        <PriavteRoute exact path="/sub-labels" component={SubLabels} />
        <PriavteRoute exact path="/view_releases/:id" component={ViewReleases} />

        {/* Redirects for backward compatibility */}
        <Redirect exact from="/releases/review" to="/audio-catalog?status=in_review" />
        <Redirect exact from="/release/approved" to="/audio-catalog?status=approved" />
        <Redirect exact from="/release/rejected" to="/audio-catalog?status=rejected" />
        <Redirect exact from="/release/takendown" to="/audio-catalog?status=takendown" />
      </Switch>
    </Router>
  );
}
